/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ILanguage } from 'app/shared/model/language.model';

export interface IPatientIdentifierName {
  id?: string;
  name?: string | null;
  country?: string | null;
  preferred?: boolean | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  language?: ILanguage | null;
}

export const defaultValue: Readonly<IPatientIdentifierName> = {
  preferred: false,
  active: false,
};
